const options = {
  5: "bg-stone-100/5",
  10: "bg-stone-100/10",
  25: "bg-stone-100/25",
  50: "bg-stone-100/50",
  75: "bg-stone-100/75",
  90: "bg-stone-100/90",
  100: "bg-stone-100",
};

const from = {
  5: "from-stone-100/5",
  10: "from-stone-100/10",
  25: "from-stone-100/25",
  50: "from-stone-100/50",
  75: "from-stone-100/75",
  90: "from-stone-100/90",
  100: "from-stone-100",
};

export default function getBackgroundStone100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
